import { EVENTS } from '@archetype-themes/utils/events'

class BlockSplitit extends HTMLElement {
  constructor() {
    super()

    this.handleVariantChange = this.handleVariantChange.bind(this)
  }
  connectedCallback() {
    this.abortController = new AbortController()

    document.addEventListener(
      `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`,
      this.handleVariantChange,
      { signal: this.abortController.signal }
    )
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  handleVariantChange({ detail }) {
    const { variant } = detail;

    if (!variant) {
      return;
    };

    const splititBannerElem = document.querySelector(`block-splitit[data-section-id="${this.dataset.sectionId}"] spt-one-liner`);
    if (splititBannerElem) {
      splititBannerElem.setAttribute('amount', (variant.price / 100).toString());

      const splititBlockElem = document.querySelector(`block-splitit[data-section-id="${this.dataset.sectionId}"]`);
      if (splititBlockElem) {
        const lowerLimit = parseInt(splititBlockElem.getAttribute('data-lower-limit-pence'), 10);
        const upperLimit = parseInt(splititBlockElem.getAttribute('data-upper-limit-pence'), 10);

        const priceTooLow = lowerLimit > 0 && variant.price < lowerLimit;
        const priceTooHigh = upperLimit > 0 & variant.price > upperLimit;

        const className = splititBlockElem.className.replace(' splitit-hide', '');

        if(priceTooLow || priceTooHigh) splititBlockElem.className = className.concat(' splitit-hide');
        else splititBlockElem.className = className;
      }
    }
  }
}

customElements.define('block-splitit', BlockSplitit)
